import { render, staticRenderFns } from "./CardAnexoProtesto.vue?vue&type=template&id=3545db21&scoped=true"
import script from "./CardAnexoProtesto.vue?vue&type=script&lang=js"
export * from "./CardAnexoProtesto.vue?vue&type=script&lang=js"
import style0 from "./CardAnexoProtesto.vue?vue&type=style&index=0&id=3545db21&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3545db21",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/dartanghanvani/Documents/workspace/recuperi-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3545db21')) {
      api.createRecord('3545db21', component.options)
    } else {
      api.reload('3545db21', component.options)
    }
    module.hot.accept("./CardAnexoProtesto.vue?vue&type=template&id=3545db21&scoped=true", function () {
      api.rerender('3545db21', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/organisms/CardAnexoProtesto.vue"
export default component.exports